import { useEffect, useRef } from "react";
import { toast } from "sonner";

// Returns the hashed main bundle path (production builds only). Empty string in dev.
const getMain = (html) => (html.match(/\/static\/js\/main\.[0-9a-f]+(?:\.chunk)?\.js/) || [""])[0];

export function UpdateNotifier() {
  const notified = useRef(false);
  useEffect(() => {
    const current = getMain(document.documentElement.outerHTML);
    if (!current) return; // dev build (no hashed bundle) — nothing to check

    const check = async () => {
      if (notified.current) return;
      try {
        const res = await fetch("/?_v=" + Date.now(), { cache: "no-store" });
        if (!res.ok) return;
        const latest = getMain(await res.text());
        if (latest && latest !== current) {
          notified.current = true;
          toast("È disponibile una nuova versione", {
            description: "Ricarica per aggiornare l'app all'ultima versione.",
            duration: Infinity,
            action: { label: "Ricarica", onClick: () => window.location.reload() },
          });
        }
      } catch (err) {
        console.debug("update check skipped (offline?):", err);
      }
    };

    const id = setInterval(check, 60000);
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    check();
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, []);

  return null;
}
